import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/common/types/applicationContext';
import { CancellationTokenManager } from '../../../shared/common/utils/cancellationTokenManager';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    telemetry: getTelemetry(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    microfrontendsAPI: createMicrofrontendsAPI({
      initHeaderApi: config.get<boolean>('header.asMicrofrontend') || false,
    }),
    cancellationTokenManager: new CancellationTokenManager(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    microfrontendsRegistry: registry(),
  };
};
